import { MinuteRange } from "Components/WorkingHours/types/MinuteRange";

export function getResizeMinutes(
	visibleMinutes: MinuteRange,
	workingMinutes: MinuteRange
): number[] {
	const resizeMinutes = [
		visibleMinutes.start,
		visibleMinutes.end,
		workingMinutes.start,
		workingMinutes.end,
	];

	for (let hour = 0; hour <= 24; hour++) {
		resizeMinutes.push(hour * 60);
	}

	const visibleResizeMinutes = resizeMinutes.filter(
		(resizeMinute) =>
			resizeMinute >= visibleMinutes.start && resizeMinute <= visibleMinutes.end
	);

	visibleResizeMinutes.sort((a, b) => a - b);

	const uniqueResizeMinutes = visibleResizeMinutes.filter(
		(minute, index, minutes) => {
			return index === minutes.indexOf(minute);
		}
	);

	return uniqueResizeMinutes;
}
